var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0888 83.9001L63.9888 63.8V63.7001C67.9888 58.7001 70.1888 52.5 70.1888 46.2001C70.1888 30.8001 57.6888 18.3 42.2888 18.3C26.8888 18.3 14.4888 30.9001 14.4888 46.2001C14.4888 61.5 26.9888 74.1 42.3888 74.1C48.6888 74.1 54.9888 71.9001 59.8888 67.9001H59.9888L79.9888 88C80.4888 88.5 81.2888 88.8 81.9888 88.8C82.6888 88.8 83.4888 88.5 83.9888 88C84.4888 87.5 84.7888 86.7 84.7888 86C84.8888 85.2 84.5888 84.5001 84.0888 83.9001ZM42.2888 68.4001C30.0888 68.4001 20.1888 58.5 20.1888 46.3C20.1888 34.1 30.0888 24.2001 42.2888 24.2001C54.4888 24.2001 64.4888 34.0001 64.4888 46.2001C64.4888 58.4001 54.5888 68.4001 42.2888 68.4001Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerca);
export default __webpack_public_path__ + "static/media/cerca.2649cd08a34e69e7087aff4d65a30246.svg";
export { ForwardRef as ReactComponent };